import * as THREE from 'three';
import { STARS } from './constants';

/**
 * Creates a starfield for the background
 */
const createStars = () => {
  const starGeometry = new THREE.BufferGeometry();
  const starMaterial = new THREE.PointsMaterial({
    color: 0xffffff,
    size: STARS.SIZE
  });

  const starVertices = [];
  for (let i = 0; i < STARS.COUNT; i++) {
    const x = (Math.random() - 0.5) * STARS.DISTRIBUTION_RANGE;
    const y = (Math.random() - 0.5) * STARS.DISTRIBUTION_RANGE;
    const z = (Math.random() - 0.5) * STARS.DISTRIBUTION_RANGE;
    starVertices.push(x, y, z);
  }

  starGeometry.setAttribute('position', new THREE.Float32BufferAttribute(starVertices, 3));
  const stars = new THREE.Points(starGeometry, starMaterial);
  
  return {
    stars,
    starGeometry,
    starMaterial
  };
};

/**
 * Cleanup function for stars
 */
const cleanupStars = (scene, { stars, starGeometry, starMaterial }) => {
  scene.remove(stars);
  starGeometry.dispose();
  starMaterial.dispose();
};

export { createStars, cleanupStars };